import { DialogStateReturn } from "reakit"

import { Modal } from "../../components/Modal"
import CaptionList from "../../components/CaptionList"

export interface GovtIntroductionGoalsModalProps {
  dialog: DialogStateReturn
}

const GovtIntroductionGoalsModal = ({
  dialog,
}: GovtIntroductionGoalsModalProps) => {
  return (
    <Modal
      header="Goals"
      aria-label="Goals"
      className="px-6 py-6 max-w-3xl"
      dialog={dialog}
    >
      <p className="mb-4">
        You selected 1 or more goals during onboarding. If you don't have one,
        you'll need to take our goal quiz. If you would like to update, you can
        edit in account information in your profile.
      </p>

      <CaptionList
        caption="Goals include:"
        list={[
          "Income Generation: Financial assistance can offset costs and provide long-term returns through improved timber management or conservation easements.",
          "Environmental and Forest Health: Programs support sustainable forestry, erosion control, and biodiversity improvements.",
          "Wildlife Conservation: Funding is available to restore habitat and support species conservation efforts.",
          "Hunting Opportunities: Government programs can help create better hunting conditions through habitat management.",
          "Recreation (Non-Hunting): Improve trails, access, and recreational areas with government support.",
          "Land Improvement/Construction: Cost-share opportunities can help fund necessary infrastructure or land restoration efforts.",
        ]}
      />
    </Modal>
  )
}

export default GovtIntroductionGoalsModal
